export default {
  name: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  cpfCnpj: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: true
  },
  rg: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: true
  },
  cnh: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: true
  },
  address: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: true
  },
  addressNumber: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: true
  },
  district: {
    value: '',
    maxlength: '70',
    required: false,
    state: null,
    disabled: true
  },
  complement: {
    value: '',
    maxlength: '70',
    required: false,
    state: null,
    disabled: true
  },
  zipcode: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    disabled: true
  },
  stateID: {
    value: null,
    options: [],
    clearOption: false,
    required: false,
    state: null,
    disabled: true
  },
  cityID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null,
    disabled: true
  },
  phoneNumber: {
    value: '',
    maxlength: '15',
    required: false,
    state: null,
    disabled: true
  },
  cellNumber: {
    value: '',
    maxlength: '15',
    required: false,
    state: null,
    disabled: true
  },
  email: {
    value: '',
    maxlength: '70',
    required: false,
    state: null,
    disabled: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/details/forms/insured-form.js